(function() {
    let tlFreeGiftOfferClone;
    let embedWidgetClone ;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                val.refreshCartContent = async () => {
                    await refreshCart();
                }
                val.getGiftsToAdd = async (rule, canClaimCount, claimedCount, parentInCart) => {
                    try {
                        let giftsToAdd = [];
                        const {GIFT_TYPE, AUTO_ADD_TYPE, MODULE_MAP_PROPERTY} = window.tlFreeGiftOffer.constants;
                        const properties = {
                            [MODULE_MAP_PROPERTY[rule.module]]: rule.id
                        }
                        if(rule.gift_type !== GIFT_TYPE.SAME_BUY){
                            if(rule.auto_add_gift){
                                if(rule.auto_add_type == AUTO_ADD_TYPE.FIRST_AVAILABLE){
                                    const fisrtAvailableGift = await window.tlFreeGiftOffer.findFirstAvailableGift(rule);
                                    if(fisrtAvailableGift?.id){
                                        giftsToAdd.push({
                                            id: fisrtAvailableGift.id, 
                                            quantity: rule.gift_qty * (canClaimCount - claimedCount),
                                            properties: {
                                                [MODULE_MAP_PROPERTY[rule.module]]: rule.id,
                                                "_salepify_product_id": fisrtAvailableGift.product_id
                                            }
                                        });
                                    }
                                }else {
                                    rule.listChilds.forEach(child =>{
                                        const quantity = child.quantity;
                                        if(quantity){
                                            giftsToAdd.push({
                                                id: child.shopify_id, 
                                                quantity: quantity * (canClaimCount - claimedCount),
                                                properties: {
                                                    [MODULE_MAP_PROPERTY[rule.module]]: rule.id,
                                                    "_salepify_product_id": child.product_id
                                                }
                                            });
                                        }
                                    })
                                }
                            }else if(window.tlFreeGiftOffer?.embedWidget?.displayRules.some((displayRule) => displayRule.id == rule.id)){
                                Array.from(window.tlFreeGiftOffer.embedWidget.selectedGiftQuantitiesByBlockId).find(([blockIndex, selectedGifts]) => {
                                    if(window.tlFreeGiftOffer.embedWidget.getResidualGifts(blockIndex) <= 0){
                                        Object.entries(selectedGifts).forEach(([id, quantity]) => {
                                            giftsToAdd.push({
                                                id, 
                                                quantity, 
                                                properties: {
                                                    [MODULE_MAP_PROPERTY[rule.module]]: rule.id,
                                                    "_salepify_product_id": id
                                                }
                                            });
                                        })
                                        return true;
                                    }

                                    return false;
                                })

                                if(giftsToAdd.length){
                                    const {canClaimCount, remain, remainSpecific, actualCanClaimCount} = window.tlFreeGiftOffer.getRuleState(rule.id);
                                    window.tlFreeGiftOffer.setRuleState(rule, canClaimCount, canClaimCount, remain, remainSpecific, actualCanClaimCount)
                                    window.tlFreeGiftOffer.embedWidget.selectedGiftQuantitiesByBlockId.clear();
                                }
                            }
                        }

                        if(window.tlFreeGiftOffer.itemsInTempCart.size){
                            await window.tlFreeGiftOffer.autoAddGiftToTempCart(rule, giftsToAdd, canClaimCount, claimedCount, parentInCart)
                            return [];
                        }else {
                            return giftsToAdd;
                        }
                    } catch (error) {
                        console.log("Error when getGiftsToAdd: ", error); 
                        return []
                    }
                }
                val.updateCartData = async () => {
                    try {
                        await window.tlFreeGiftOffer.detectCartData();

                        const { isUpdateCart, eligibleOtherRules } = await window.tlFreeGiftOffer.checkAllRule();

                        if(isUpdateCart){
                            // Prevent Reload
                            await window.tlFreeGiftOffer.refreshCartContent();
                        }else {
                            // Render
                            window.tlFreeGiftOffer.showPopupOffer(eligibleOtherRules)
                            window.tlFreeGiftOffer.showEmbedOffer();
                        }
                    } catch (error) {
                        console.log("Error when checkCartData: ", error);
                    }
                }
            }
        },
        configurable: true
    });
})();